<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4D20M/4D20M.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4D20M 2.0T柴油发动机</div>
        <div class="detail-banner-desc">
          全新一代2.0T高性能低油耗柴油发动机。
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">强动力</div>
    <div class="detail-desc">高扭矩起始转速更低、扭矩更大、持续转速范围更广，加速更平顺、动力随叫随到，提升行驶质感。</div>
    <div class="detail-utils">
      <div class="detail-utils-item">
        <div class="detail-utils-d">最大功率</div>
        <div class="detail-utils-u">120kW 3600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">最大扭矩</div>
        <div class="detail-utils-u">400N·m 1400~2600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">低速扭矩</div>
        <div class="detail-utils-u">1000r/min 210N·m，1200r/min 300N·m</div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-1.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            高效电控VGT增压器
          </div>
          <div class="detail-desc">
            增压器效率全面提升，进一步提升起步、加速动力及燃油经济性。
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              210N·m
            </div>
            <div class="detail-swiper-d">
              低速动力性（1000r/min）
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">低油耗、低排放</div>
    <div class="detail-desc">采用碗型燃烧室、高效率螺旋切向气道，匹配2000bar高压共轨系统，并应用多项减摩降损措施，使燃烧更充分，油耗更低。</div>
    
    
    

    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-3.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          高压共轨系统
        </div>
        <div class="detail-four-desc">
          2000bar系统压力配合高速电磁式喷油器，极大提升燃油雾化效果，燃烧更充分。
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          高压EGR系统
        </div>
        <div class="detail-four-desc">
          采用高压EGR技术，降低发动机泵气损失和降低Nox排放，提升整车燃油经济性。
        </div>
      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-4.jpg" alt=""></img>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            进气系统优化
          </div>
          <div class="detail-desc">
            采用螺旋切向进气道、缸盖进气口增加导向遮蔽结构，优化进气形态，改善流场强度，提高空气利用率，显著提升燃油经济性。
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              60%
            </div>
            <div class="detail-swiper-d">
              涡流比提升
            </div>
          </div>
        </div>
      </div>
      
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-2.jpg" alt=""></img>
      </div>
    </div>

  </div>


  <div class="detail-box">
    <div class="detail-title">NVH</div>
    <div class="detail-desc">媲美汽油机NVH体验，以打造最好听的柴油机为目标，从主被动两方面提升开发。</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-5.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          凸轮轴并联结合消隙齿轮
        </div>
        <div class="detail-four-desc">
          采用消隙齿轮，对副齿扭簧刚度进行最优匹配，在优化凸轮轴扭振幅值基础上，齿轮振动改善74%，解决齿轮敲击和啸叫两个典型NVH问题，发动机齿轮敲击噪声降低5dBA。
        </div>

      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          正时系统优化设计
        </div>
        <div class="detail-four-desc">
          正时皮带和带轮匹配合理相位，降低正时皮带张力，改善皮带与带轮的啮合噪声。相对于链条系统，皮带系统拥有更低的噪声，配合上部塑料、下部铸铝的正时罩盖，对正时侧高频和低频噪声均有良好的屏蔽作用。
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-6.jpg" alt=""></img>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-7.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            平衡轴底置一体式
          </div>
          <div class="detail-desc">
            提升整车NVH舒适性，增加平衡轴配置，驱动齿轮布置在曲轴前端，降低扭振激励，减少齿轮敲击噪声，实测发动机底部辐射噪声降低5dBA以上。
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              ＞5dBA
            </div>
            <div class="detail-swiper-d">
              噪声降低
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>


  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '4D20M 2.0T柴油发动机 - 蜂巢汽车官网',
  keywords: '蜂巢,蜂巢汽车,发动机,变速箱,电子',
  description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
  outputPath: 'engine/4D20M.html'
};

import { createApp } from 'vue';
import App from './4D20M.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4D20M.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>